import React from 'react';
import SuggestedWordTextItem from './suggested_word_text_item';
import PropTypes from 'prop-types';
import { WordSearchShape } from '../shapes';
import Downshift from 'downshift';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';

export default class WordSearch extends React.Component {
  static propTypes = {
    wordSearchObject: WordSearchShape,
    onSearch: PropTypes.func
  }

  state = {
    timeout: undefined,
    wordText: undefined,
    next: false
  };

  onStateChange(_, changes) {
    if (changes.type === Downshift.stateChangeTypes.keyDownEnter) {
      this.onNext();
    }
    return changes;
  }

  onNext() {
    if (this.state.wordText) {
      this.setState({ next: true });
    }
  }

  render() {
    if (this.state.next) {
      return (
        <Redirect push to={ `/words/${this.state.wordText}` }></Redirect>
      )
    } else {
      return (
        <div className='word-search'>
          <Downshift
            onStateChange={ this.onStateChange.bind(this) }
            onInputValueChange={ this.onSearchInputChange }
            render={({
              getInputProps,
              getItemProps,
              highlightedIndex,
              isOpen
            }) => (
              <div className='row'>
                <div className='col-sm-10'>
                  <input { ...getInputProps({
                      onBlur: (event) => event.preventDefault(),
                      onKeyDown: this.onKeyDown.bind(this),
                      type: 'text',
                      className: 'input-text search lowercase',
                      placeholder: 'Start by typing a word...',
                    }) }
                  />
                  {isOpen ? (
                    <div className='suggested-search-results'>
                      {this.props.wordSearchObject.get('suggestedWordTexts').map((suggestedWordText, i) => (
                        <SuggestedWordTextItem key={ i } suggestedWordText={ suggestedWordText } downshiftItemProps={ getItemProps } index={ i } currentIndex={ highlightedIndex } />
                      ))}
                     </div>
                  ) : null }
                </div>
                <div className='col-sm-2 action'>
                  { this.renderNextButton() }
                </div>
              </div>
            )}
          />
      </div>
      );
    }
  }

  renderNextButton() {
    if (this.state.wordText) {
      return (
        <Link to={ `words/${this.state.wordText}` } className='btn btn-dark'>Next</Link>
      );
    } else {
      return (
        <a className='btn btn-outline-light disabled' disabled={ true }>Next</a>
      );
    }
  }

  onTyping(wordText) {
    if (this.state.timeout) {
      clearTimeout(this.state.timeout);
    }

    const timeout = setTimeout(() => {
      if (wordText.length > 2) {
        this.props.onSearch(wordText);
      }
    }, 500);

    this.setState({ timeout: timeout });
  }

  onSearchInputChange = (wordText ) => {
    if (wordText && wordText.length > 0) {
      this.onTyping(wordText);
      this.setState({ wordText: wordText });
    }
  }

  onKeyDown(event) {
    if (event.key === 'Enter') {
      this.onNext();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/word_search.jsx